import axios from 'axios'
import router from '@/router.js'
import config from '@/config'
import alert from '@/helpers/alert'
import authHelper from '@/helpers/auth'


export default {
  namespaced: true,
  state: {
    showDrawer: false,
    isAuthenticated: false,
    user: {},
    teams: {
      PropertyManager: null,
      Handyman: null,
      Performer: null,
    },
  },
  getters: {
    getDrawer: (state) => state.showDrawer,
    getIsAuthenticated: (state) => state.isAuthenticated,
    getUser: (state) => state.user,
    getTeams: (state) => role => {
      const team = state.teams[role];
      return team;
    },
  },
  mutations: {
    setDrawer(state, status) {
      state.showDrawer = status
    },
    setIsAuthenticated(state, status) {
      const user = authHelper.isAuthenticated()

      if (user) {
        state.isAuthenticated = status
      } else {
        state.isAuthenticated = false
      }
    },
    setUser(state, user) {
      state.user = user;
    },
    setTeam(state, {role, team} ) {
      state.teams[role] = team;
    }
  },
  actions: {
    init(context) {
      if (authHelper.isAuthenticated()) {
        context.commit('setIsAuthenticated', true)
        context.dispatch('Configuration/init', null, { root: true })
      }
    },
    async loggingIn(context, { username, password }) {
      const url = config.apiBaseUrl + 'account/login'

      try {
        const response = await axios.post(url, {
          account: username,
          password: password,
        })

        if (response.data.errmsg === '') {
          authHelper.setUser(response)
          const user = authHelper.getUser()
          // console.log({user})
          context.commit('setUser', user)
          context.commit('setDrawer', true)
          context.commit('setIsAuthenticated', true)
          context.dispatch('Configuration/init', null, { root: true })

          router.push('/home')
        } else {
          alert.error(response.data.errmsg)
        }
      } catch (error) {
        alert.error(error)
      }
    },
    async fetchTeam(context, { role }) {
      const url = config.apiBaseUrl + 'account/team'
      try {
        const response = await axios.get(url, { params: {role} })
        if (response.data.errno === 0) {
          const team = response.data.data;
          context.commit('setTeam', {role, team });
        } else {
          alert.error(response.data.errmsg)
        }
      } catch (error) {
        alert.error(error)
      }
    },

    loggingOut(context) {
      window.sessionStorage.removeItem('user')

      context.commit('setDrawer', false)
      context.commit('setIsAuthenticated', false)
      router.push('/')
    },
    async forgetPasssword(context, { email }) {
      const url = config.apiBaseUrl + 'account/forget'

      try {
        const response = await axios.post(url, { email: email })

        if (response.data.errmsg) {
          alert.error(response.data.errmsg)
        } else {
          alert.success(
            'Password reset instructions have been sent to your email.'
          )
        }
      } catch (error) {
        alert.error(
          'Sorry, we cannot process your request right now. Please try again by refreshing your browser.'
        )
      }
    },
    toggleDrawer(context) {
      context.commit('setDrawer', !context.getters.getDrawer)
    },
  },
}
